import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { FlowRoutingModule } from 'app/modules/flow/flow-routing.module';
import { AngularMaterialModule, SharedModule } from '../../shared';
import { CoreModule } from '../../core/core.module';

import { CommonModule } from '@angular/common';
import { FlowEditDeliveryComponent } from '../flow/flow-edit-delivery/flow-edit-delivery.component';
import { FlorderModule } from 'app/modules/florder/florder.module';
import { FlowEditContainer } from '../flow/flow-edit-container/flow-edit.container';
import { FlowEditDetailComponent } from '../flow/flow-edit-detail/flow-edit-detail.component';
import { FlowEditPlanningComponent } from '../flow/flow-edit-planning/flow-edit-planning.component';
import { FlowEditMaterialComponent } from '../flow/flow-edit-material/flow-edit-material.component';
import { FlowMaterialLinesComponent } from '../flow/flow-material-lines/flow-material-lines.component';
import { PoNumberAsyncValidator } from '../florder/florder-edit-delivery/po-number-async-validator';

@NgModule({
  imports: [CommonModule, FlorderModule, FlowRoutingModule, AngularMaterialModule, SharedModule, CoreModule, ReactiveFormsModule],
  declarations: [
    FlowEditContainer,
    FlowEditDeliveryComponent,
    FlowEditDetailComponent,
    FlowEditPlanningComponent,
    FlowEditMaterialComponent,
    FlowMaterialLinesComponent,
  ],
  providers: [PoNumberAsyncValidator],
})
export class FlowModule {}
